import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { fetchTwitter } from 'api/api'

const initialState: TemplateType = {
  title: '',
  content: '',
  photo: '',
  id: '',
  imageURL: '',
  imageKey: '',
  isActive: true,
  imageOriginalName: '',
}

const twitterSlice = createSlice({
  name: 'twitter',
  initialState,
  reducers: {
    setTwitterData: (state, { payload }) => {
      return {
        ...state,
        title: payload.title,
        content: payload.content,
        photo: payload.photo,
        id: payload.id,
        imageURL: payload.imageURL,
        imageKey: payload.imageKey,
        isActive: payload.isActive,
        imageOriginalName: payload.imageOriginalName,
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTwitter.fulfilled, (state, action) => {
      return {
        ...state,
        title: action.payload.title,
        content: action.payload.content,
        photo: action.payload.imageOriginalName,
        id: action.payload.id || state.id,
        imageURL: action.payload.imageURL,
        imageKey: action.payload.imageKey,
        isActive: action.payload.isActive,
        imageOriginalName: action.payload.imageOriginalName,
      }
    })
  },
})

export const getTwitterData = (state: RootState) => state.twitter

export const { setTwitterData } = twitterSlice.actions

export default twitterSlice.reducer
